import React, { useRef } from "react";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { getImages } from "../../../const";

const ImageCrop = ({ image, close, onCrop }) => {

    const cropperRef = useRef(null);
    const handleCrop = () => {
        const cropper = cropperRef.current?.cropper;

        if (!cropper) return;

        const croppedCanvas = cropper.getCroppedCanvas({
            width: 1080,
            height: 1920
        });

        const croppedImage = croppedCanvas.toDataURL("image/jpeg");

        onCrop(croppedImage);
    };

    return (
        <>
            <div className="modal-content image-crop-content">
                <div className="modal-body">
                    
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('m-modal-x.svg')} />
                    </button>
                    <div className="sm-title text-start text-black w-100 mb-3">Crop Photo</div>
                    <Cropper
                        ref={cropperRef}
                        src={image}
                        style={{ height: 450, width: "100%" }}
                        aspectRatio={9 / 16}
                        viewMode={1}
                        dragMode="move"
                        cropBoxMovable={true}
                        cropBoxResizable={true}
                        autoCropArea={1}
                        movable={true}
                        zoomable={true}
                        scalable={true}
                        background={false}
                        responsive={true}
                        guides={true}
                    />
                    <div className="w-100 text-end mt-5">
                        <button className="btn common-btn px-4 btn-transparent text-center fw-700 xss-title me-3" onClick={close}>
                            Cancel
                        </button>
                        <button className="btn common-btn px-4 w-260 xss-title fw-700 text-center" onClick={handleCrop}>
                            Done
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImageCrop;